export default "__VITE_ASSET__b577f7f6__"